export interface RefinementMenu {
  attribute: string;
  component: 'CollapsibleRefinementList';
  conditional?: boolean;
  header: string;
  operator: 'and' | 'or';
}

export const plpRefinementMenus: RefinementMenu[] = [
  {
    attribute: 'Product.facets.value',
    component: 'CollapsibleRefinementList',
    header: 'value',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.roast',
    component: 'CollapsibleRefinementList',
    header: 'roast',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.salt',
    component: 'CollapsibleRefinementList',
    header: 'salt',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.chocolate',
    component: 'CollapsibleRefinementList',
    header: 'chocolate',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.product type',
    component: 'CollapsibleRefinementList',
    header: 'type',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.use case',
    component: 'CollapsibleRefinementList',
    header: 'use case',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.region',
    component: 'CollapsibleRefinementList',
    header: 'region',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.flavor',
    component: 'CollapsibleRefinementList',
    conditional: true,
    header: 'flavor',
    operator: 'and',
  },
  {
    attribute: 'Product.searchableTags',
    component: 'CollapsibleRefinementList',
    header: 'tags',
    operator: 'and',
  },
];

export const searchRefinementMenus = [...plpRefinementMenus];
